<template>
  <v-layout wrap>
    <!-- <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    /> -->
    <v-flex>
      <v-img
        class="white--text align-center"
        :style="
          $vuetify.breakpoint.name == 'xs'
            ? 'height: 815px'
            : $vuetify.breakpoint.name == 'sm'
            ? 'height: 1030px'
            : $vuetify.breakpoint.name == 'md'
            ? 'height: 1370px'
            : $vuetify.breakpoint.name == 'lg'
            ? 'height: 820px'
            : (style = 'height: 100%')
        "
        src="../../assets/images/Asset 1.png"
      >
        <v-layout wrap justify-center text-center>
          <v-flex md4 align-self-center>
            <v-form>
              <v-layout wrap align-self-center text-center>
                <v-flex xs12>
                  <v-img
                    height="300px"
                    contain
                    src="../../assets/images/Component3.png"
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 pt-5 class="head">Hello, </v-flex>
                <v-flex v-if="user" xs12 class="font1" style="font-size: 20px"
                  >{{ user.name }}
                </v-flex>
                <v-flex xs12 class="head" pt-5> Welcome to </v-flex>
                <v-flex xs12 class="head"> School Management System </v-flex>
                <v-flex xs12> </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-img>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ServerError: false,
      showsnackbar: false,
      appLoading: false,
      user: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // if (response.data.status) {
          this.user = response.data.data;
          setTimeout(
            function () {
              this.homeload = false;
              // alert('cool');
            }.bind(this),
            10000
          );
          if (response.data.data.currentRole == "Admin") {
            this.$router.push({ path: "/appDashboard" });
          } 
          // else (response.data.data.currentRole == "SuperAdmin");
          // {
          //   this.$router.push({ path: "/SuperadminDashboard" });
          // }
          else
          this.$router.push({ path: "/SuperadminDashboard" });
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>